import { useContext } from 'react'
import { AuthContext } from './context/auth-context'
import App from './App.jsx'
import Login from './Login.jsx'
import LoadingIndicator from '@/widgets/LoadingIndicator.jsx'

export default function AuthenticatedApp() {
  const { user, loading } = useContext(AuthContext)
  // console.log(`Loading auth app`)

  if (loading) {
    return (<LoadingIndicator message="Loading..." />)
  }

  return user ? <App /> : <Login />
}
